/**
 * Literales de UI del módulo LotoWheel — módulos extra:
 *   lotowheel-simulator.js, lotowheel-modal-algoritmo.js,
 *   lotowheel-modal-acceso.js, lotowheel-modal-pozos.js,
 *   lotowheel-modal-fichas.js, lotowheel-modal-virtual-draws.js,
 *   lotowheel-modal-bloqueos.js.
 *
 * Clave = texto español EXACTO tal como aparece en el código (estilo gettext).
 * Solo columna pt (Fase 1). Los literales globales (Guardar, Cancelar, Activo,
 * Inactivo, Estado, Fecha, Tipo, Motivo, Notas, Acciones, Sorteos, etc.) ya
 * viven en los diccionarios base y NO se re-declaran aquí.
 *
 * Terminología: roda (nunca roleta), sorteio, aposta, poço, giro.
 * Términos técnicos del simulador (RTP, σ, EV, GGR, drawdown, percentil,
 * volatilidad como metric label) NO se traducen — quedan fuera de t().
 */

export const DICCIONARIO_LOTOWHEEL_EXTRA = {

    // ── lotowheel-simulator.js — selects y overlay ──────────────────────────
    'Sin comparación': { pt: 'Sem comparação', en: 'No comparison', ru: 'Без сравнения' },
    'Configuración modificada': { pt: 'Configuração modificada', en: 'Configuration modified', ru: 'Конфигурация изменена' },
    'Simulando...': { pt: 'Simulando...', en: 'Simulating...', ru: 'Симуляция...' },
    'Simulando': { pt: 'Simulando', en: 'Simulating', ru: 'Симуляция' },

    // ── Escenarios ──────────────────────────────────────────────────────────
    'Flujo constante de jugadores, sin eventos especiales': {
        pt: 'Fluxo constante de jogadores, sem eventos especiais',
        en: 'Steady flow of players, no special events',
        ru: 'Постоянный поток игроков, без особых событий',
    },
    'Arranque con muchas llegadas que se estabilizan gradualmente': {
        pt: 'Início com muitas chegadas que se estabilizam gradualmente',
        en: 'Start with many arrivals that gradually stabilize',
        ru: 'Старт с большим наплывом, постепенно стабилизирующимся',
    },
    'Un grupo apuesta fuerte al mismo número durante un periodo': {
        pt: 'Um grupo aposta forte no mesmo número durante um período',
        en: 'A group bets heavily on the same number for a period',
        ru: 'Группа делает крупные ставки на одно число в течение периода',
    },
    'La casa arranca con pérdida y simula hasta recuperar': {
        pt: 'A casa começa com prejuízo e simula até recuperar',
        en: 'The house starts at a loss and simulates until it recovers',
        ru: 'Заведение начинает с убытка и симулирует до восстановления',
    },

    // ── Períodos del simulador ───────────────────────────────────────────────
    '~1 día': { pt: '~1 dia', en: '~1 day', ru: '~1 день' },
    '~3 días': { pt: '~3 dias', en: '~3 days', ru: '~3 дня' },
    '~1 semana': { pt: '~1 semana', en: '~1 week', ru: '~1 неделя' },
    '~2 semanas': { pt: '~2 semanas', en: '~2 weeks', ru: '~2 недели' },
    '~1 mes': { pt: '~1 mês', en: '~1 month', ru: '~1 месяц' },
    '~3 meses': { pt: '~3 meses', en: '~3 months', ru: '~3 месяца' },

    // ── Labels de gráficas (Chart.js) ────────────────────────────────────────
    'Ganancia Casa (% neto por local)': { pt: 'Ganho Casa (% líquido por local)', en: 'House Profit (% net per location)', ru: 'Прибыль заведения (% чистая на точку)' },
    'Ganancia Casa — ': { pt: 'Ganho Casa — ', en: 'House Profit — ', ru: 'Прибыль заведения — ' },
    'Ganancia Jugador (% neto)': { pt: 'Ganho Jogador (% líquido)', en: 'Player Profit (% net)', ru: 'Прибыль игрока (% чистая)' },
    'Ganancia Jugador — ': { pt: 'Ganho Jogador — ', en: 'Player Profit — ', ru: 'Прибыль игрока — ' },
    'Balance Casa / Drawdown (%)': { pt: 'Saldo Casa / Drawdown (%)', en: 'House Balance / Drawdown (%)', ru: 'Баланс заведения / Drawdown (%)' },
    'Balance Casa — ': { pt: 'Saldo Casa — ', en: 'House Balance — ', ru: 'Баланс заведения — ' },
    'Ratio Pago/Recaudo por sorteo': { pt: 'Ratio Pago/Arrecadação por sorteio', en: 'Payout/Revenue Ratio per draw', ru: 'Отношение выплат/сборов на розыгрыш' },
    'Multiplicador por jugada': { pt: 'Multiplicador por jogada', en: 'Multiplier per play', ru: 'Множитель за ход' },
    'Local ': { pt: 'Local ', en: 'Location ', ru: 'Точка ' },
    '10% peor': { pt: '10% pior', en: '10% worst', ru: '10% худших' },
    '50% (típico)': { pt: '50% (típico)', en: '50% (typical)', ru: '50% (типично)' },
    '90% mejor': { pt: '90% melhor', en: '90% best', ru: '90% лучших' },

    // ── KPI labels (panel de métricas) ───────────────────────────────────────
    'Casa': { pt: 'Casa', en: 'House', ru: 'Заведение' },
    'Margen': { pt: 'Margem', en: 'Margin', ru: 'Маржа' },
    'Sorteos Rojo': { pt: 'Sorteios Vermelho', en: 'Red Draws', ru: 'Розыгрыши в минусе' },
    'Max Premio': { pt: 'Prêmio Máx', en: 'Max Prize', ru: 'Макс. приз' },
    'Recuperación': { pt: 'Recuperação', en: 'Recovery', ru: 'Восстановление' },
    'Déficit': { pt: 'Déficit', en: 'Deficit', ru: 'Дефицит' },
    'Jugador': { pt: 'Jogador', en: 'Player', ru: 'Игрок' },
    'Reciclaje': { pt: 'Reciclagem', en: 'Recycling', ru: 'Переигрывание' },
    'Dinero Fresco': { pt: 'Dinheiro Novo', en: 'Fresh Money', ru: 'Свежие деньги' },
    'Rejuego': { pt: 'Rejogo', en: 'Replay', ru: 'Повторная игра' },
    'Sesión (sorteos)': { pt: 'Sessão (sorteios)', en: 'Session (draws)', ru: 'Сессия (розыгрыши)' },
    'Win Rate': { pt: 'Taxa de Ganho', en: 'Win Rate', ru: 'Частота выигрыша' },
    'Percepción del Jugador': { pt: 'Percepção do Jogador', en: 'Player Perception', ru: 'Восприятие игрока' },
    'Racha Seca (med)': { pt: 'Sequência Seca (med)', en: 'Dry Streak (med)', ru: 'Серия без выигрыша (медиана)' },
    'Racha Seca P90': { pt: 'Sequência Seca P90', en: 'Dry Streak P90', ru: 'Серия без выигрыша P90' },
    '1er Premio (med)': { pt: '1º Prêmio (med)', en: '1st Prize (med)', ru: '1-й приз (медиана)' },
    'Explosión 5x (freq)': { pt: 'Explosão 5x (freq)', en: '5x Burst (freq)', ru: 'Взрыв 5x (частота)' },
    'Proximidad Pleno ±1': { pt: 'Proximidade Pleno ±1', en: 'Straight-up Proximity ±1', ru: 'Близость к прямой ставке ±1' },
    'No recuperado': { pt: 'Não recuperado', en: 'Not recovered', ru: 'Не восстановлено' },
    'Sorteos para recuperar': { pt: 'Sorteios para recuperar', en: 'Draws to recover', ru: 'Розыгрышей до восстановления' },
    'Hasta recuperar $': { pt: 'Até recuperar $', en: 'Until recovering $', ru: 'До восстановления $' },
    'Error en simulacion: ': { pt: 'Erro na simulação: ', en: 'Simulation error: ', ru: 'Ошибка симуляции: ' },

    // ── lotowheel-modal-algoritmo.js ─────────────────────────────────────────
    'sistema': { pt: 'sistema', en: 'system', ru: 'система' },
    'Modificado': { pt: 'Modificado', en: 'Modified', ru: 'Изменено' },
    'Este algoritmo no tiene parametros configurables.': {
        pt: 'Este algoritmo não tem parâmetros configuráveis.',
        en: 'This algorithm has no configurable parameters.',
        ru: 'У этого алгоритма нет настраиваемых параметров.',
    },
    'Copia de ': { pt: 'Cópia de ', en: 'Copy of ', ru: 'Копия ' },
    'Preset cargado: ': { pt: 'Preset carregado: ', en: 'Preset loaded: ', ru: 'Пресет загружен: ' },
    'Preset duplicado: ': { pt: 'Preset duplicado: ', en: 'Preset duplicated: ', ru: 'Пресет продублирован: ' },
    'Preset renombrado: ': { pt: 'Preset renomeado: ', en: 'Preset renamed: ', ru: 'Пресет переименован: ' },
    'Preset eliminado': { pt: 'Preset excluído', en: 'Preset deleted', ru: 'Пресет удалён' },
    'Nombre del preset:': { pt: 'Nome do preset:', en: 'Preset name:', ru: 'Название пресета:' },
    'Descripcion (opcional):': { pt: 'Descrição (opcional):', en: 'Description (optional):', ru: 'Описание (необязательно):' },
    'Preset guardado: ': { pt: 'Preset salvo: ', en: 'Preset saved: ', ru: 'Пресет сохранён: ' },
    'Error al guardar preset: ': { pt: 'Erro ao salvar preset: ', en: 'Error saving preset: ', ru: 'Ошибка сохранения пресета: ' },
    'Error generando config desde sliders': { pt: 'Erro ao gerar config a partir dos sliders', en: 'Error generating config from sliders', ru: 'Ошибка генерации конфигурации из ползунков' },

    // ── lotowheel-modal-acceso.js — badges de estado ─────────────────────────
    'Cerrado a todos': { pt: 'Fechado para todos', en: 'Closed to all', ru: 'Закрыто для всех' },
    'ningún operador puede ver este sorteo.': { pt: 'nenhum operador pode ver este sorteio.', en: 'no operator can see this draw.', ru: 'ни один оператор не видит этот розыгрыш.' },
    'Abierto a todos': { pt: 'Aberto para todos', en: 'Open to all', ru: 'Открыто для всех' },
    'cualquier operador puede ver este sorteo.': { pt: 'qualquer operador pode ver este sorteio.', en: 'any operator can see this draw.', ru: 'любой оператор видит этот розыгрыш.' },
    'Restringido — ': { pt: 'Restrito — ', en: 'Restricted — ', ru: 'Ограничено — ' },
    ' excluido': { pt: ' excluído', en: ' excluded', ru: ' исключён' },
    ' excluidos': { pt: ' excluídos', en: ' excluded', ru: ' исключены' },
    ' operador': { pt: ' operador', en: ' operator', ru: ' оператор' },
    ' operadores': { pt: ' operadores', en: ' operators', ru: ' операторы' },
    'solo los marcados (y sus descendientes) lo verán.': {
        pt: 'somente os marcados (e seus descendentes) poderão ver.',
        en: 'only the marked ones (and their descendants) will see it.',
        ru: 'только отмеченные (и их потомки) увидят его.',
    },
    'Sin permisos para gestionar accesos de este sorteo.': {
        pt: 'Sem permissão para gerenciar acessos deste sorteio.',
        en: 'No permission to manage access for this draw.',
        ru: 'Нет прав на управление доступом к этому розыгрышу.',
    },
    'No hay operadores disponibles.': { pt: 'Não há operadores disponíveis.', en: 'No operators available.', ru: 'Нет доступных операторов.' },
    'No tienes suboperadores configurados.': { pt: 'Você não tem suboperadores configurados.', en: 'You have no suboperators configured.', ru: 'У вас не настроены субоператоры.' },
    'Cuando tengas suboperadores podrás restringir cuáles acceden a este sorteo.': {
        pt: 'Quando tiver suboperadores, poderá restringir quais acessam este sorteio.',
        en: 'Once you have suboperators you can restrict which ones access this draw.',
        ru: 'Когда появятся субоператоры, вы сможете ограничить доступ к этому розыгрышу.',
    },
    'Acceso abierto — sorteo visible para todos': {
        pt: 'Acesso aberto — sorteio visível para todos',
        en: 'Open access — draw visible to all',
        ru: 'Открытый доступ — розыгрыш виден всем',
    },
    'operador(es) autorizados': { pt: 'operador(es) autorizado(s)', en: 'authorized operator(s)', ru: 'авторизованных оператор(ов)' },
    'Accesos guardados: ': { pt: 'Acessos salvos: ', en: 'Access settings saved: ', ru: 'Доступы сохранены: ' },

    // ── lotowheel-modal-pozos.js ─────────────────────────────────────────────
    'Sin jackpots disponibles': { pt: 'Sem poços disponíveis', en: 'No jackpots available', ru: 'Нет доступных джекпотов' },
    'Crea un jackpot en la sección "Pozos Comunes" del menú lateral.': {
        pt: 'Crie um poço na seção "Poços Comuns" do menu lateral.',
        en: 'Create a jackpot in the "Common Pools" section of the side menu.',
        ru: 'Создайте джекпот в разделе «Общие пулы» бокового меню.',
    },
    'Bote: ': { pt: 'Bote: ', en: 'Jackpot: ', ru: 'Джекпот: ' },
    '% del umbral de disparo (': { pt: '% do limite de disparo (', en: '% of the trigger threshold (', ru: '% от порога срабатывания (' },
    '% de cada apuesta que aporta': { pt: '% de cada aposta que contribui', en: '% of each bet that contributes', ru: '% от каждой ставки в пул' },
    'Pausa al disparar': { pt: 'Pausa ao disparar', en: 'Pause on trigger', ru: 'Пауза при срабатывании' },
    'Sin pausa': { pt: 'Sem pausa', en: 'No pause', ru: 'Без паузы' },
    '15 segundos': { pt: '15 segundos', en: '15 seconds', ru: '15 секунд' },
    '30 segundos': { pt: '30 segundos', en: '30 seconds', ru: '30 секунд' },
    '1 minuto': { pt: '1 minuto', en: '1 minute', ru: '1 минута' },
    'Suscripciones guardadas: ': { pt: 'Assinaturas salvas: ', en: 'Subscriptions saved: ', ru: 'Подписки сохранены: ' },
    ' pozo(s) activo(s)': { pt: ' poço(s) ativo(s)', en: ' active pool(s)', ru: ' активных пул(ов)' },

    // ── lotowheel-modal-fichas.js ─────────────────────────────────────────────
    'Vista': { pt: 'Visual', en: 'View', ru: 'Вид' },

    // ── lotowheel-modal-virtual-draws.js ─────────────────────────────────────
    'No hay sorteos virtuales activos': { pt: 'Não há sorteios virtuais ativos', en: 'No active virtual draws', ru: 'Нет активных виртуальных розыгрышей' },
    'ID del sorteo virtual (ej: vdraw:user:test):': {
        pt: 'ID do sorteio virtual (ex: vdraw:user:test):',
        en: 'Virtual draw ID (e.g., vdraw:user:test):',
        ru: 'ID виртуального розыгрыша (напр.: vdraw:user:test):',
    },
    'ID del LotoWheel base (template):': { pt: 'ID do LotoWheel base (template):', en: 'Base LotoWheel ID (template):', ru: 'ID базового LotoWheel (шаблон):' },
    'Propietario': { pt: 'Proprietário', en: 'Owner', ru: 'Владелец' },
    'Ejecutar sorteo': { pt: 'Executar sorteio', en: 'Run draw', ru: 'Запустить розыгрыш' },
    'Detener': { pt: 'Parar', en: 'Stop', ru: 'Остановить' },
    ' sorteos recuperados': { pt: ' sorteios recuperados', en: ' draws recovered', ru: ' розыгрышей восстановлено' },
    'Sorteo virtual creado: ': { pt: 'Sorteio virtual criado: ', en: 'Virtual draw created: ', ru: 'Виртуальный розыгрыш создан: ' },
    'Sorteo ejecutado: ': { pt: 'Sorteio executado: ', en: 'Draw executed: ', ru: 'Розыгрыш выполнен: ' },
    '¿Detener sorteo virtual ': { pt: 'Parar sorteio virtual ', en: 'Stop virtual draw ', ru: 'Остановить виртуальный розыгрыш ' },
    'Sorteo detenido: ': { pt: 'Sorteio parado: ', en: 'Draw stopped: ', ru: 'Розыгрыш остановлен: ' },

    // ── lotowheel-modal-algoritmo.js ─────────────────────────────────────────
    'Eliminar preset "': { pt: 'Excluir preset "', en: 'Delete preset "', ru: 'Удалить пресет «' },
    '"?': { pt: '"?', en: '"?', ru: '»?' },

    // ── lotowheel-modals.js — panel visual ────────────────────────────────────
    'Tema Visual': { pt: 'Tema Visual', en: 'Visual Theme', ru: 'Визуальная тема' },
    'Ticket (POS / cashier / TV)': { pt: 'Ticket (POS / caixa / TV)', en: 'Ticket (POS / cashier / TV)', ru: 'Билет (POS / касса / ТВ)' },
    'Wallet (jugador identificado)': { pt: 'Wallet (jogador identificado)', en: 'Wallet (identified player)', ru: 'Кошелёк (идентифицированный игрок)' },

    // ── lotowheel-modal-bloqueos.js ───────────────────────────────────────────
    'No hay bloqueos activos': { pt: 'Não há bloqueios ativos', en: 'No active blocks', ru: 'Нет активных блокировок' },
    'Identificador requerido': { pt: 'Identificador obrigatório', en: 'Identifier required', ru: 'Требуется идентификатор' },
    'Bloqueo creado': { pt: 'Bloqueio criado', en: 'Block created', ru: 'Блокировка создана' },
    'Desbloquear este registro?': { pt: 'Desbloquear este registro?', en: 'Unblock this record?', ru: 'Разблокировать эту запись?' },
    'Bloqueo eliminado': { pt: 'Bloqueio excluído', en: 'Block removed', ru: 'Блокировка удалена' },
};
